export default {
      id: "new-arrow-icon-usage",
      viewBox: "0 0 8 13",
      url: __webpack_public_path__ + "sprite.svg#new-arrow-icon",
      toString: function () {
        return this.url;
      }
    }